export enum InitialAssessmentConstants {
  SET_SELECTED_OPTION = 'InitialAssessment/SET_SELECTED_OPTION',
  NEURO = 'InitialAssessment/NEURO',
  AIRWAY = 'InitialAssessment/AIRWAY',
  RESPIRATORY = 'InitialAssessment/RESPIRATORY',
  CARDIO = 'InitialAssessment/CARDIO',
  SET_PR_NABC_DEFAULTS = 'InitialAssessment/SET_PR_NABC_DEFAULTS',
}
